module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av595-7f376a9f237973c08aa0695fc1195a12.jpg";